module.exports = __webpack_public_path__ + "img/logo.6eba6f08.png";